import React, { useState } from "react";
import cn from "classnames";
import styles from "./Header.module.sass";
import { Link } from "react-router-dom";
import Icon from "../Icon";
// import Search from "./Search";
import Messages from "./Messages";
import Notification from "./Notification";
import User from "./User";

const Header = ({ onOpen }) => {
  const [visible, setVisible] = useState(false);
  const handleClick = () => {
    onOpen();
    setVisible(false);
  };

  return (
    <header className={styles.header}>
      <button className={styles.burger} onClick={() => handleClick()}></button>
      {/* <Search className={cn(styles.search, { [styles.visible]: visible })} /> */}
      <div className={styles.control} onClick={() => setVisible(false)}>
        <Notification className={styles.notification} />
        <User className={styles.user} />
      </div>
    </header>
  );
};

export default Header;
